import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ProfileService } from '../../shared/profile.service';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { TranslationService } from '../../shared/translation.service';

@Component({
  selector: 'lp2-personal-photo',
  templateUrl: './personal-photo.component.html',
  styleUrls: ['./personal-photo.component.scss'],
})
export class PersonalPhotoComponent implements OnInit {
  @ViewChild('photoSavedTemplate')
  photoSavedTemplate: ElementRef;

  hasPhoto: boolean;

  photoForm = new FormGroup({
    image: new FormControl(''),
  });

  isRequesting = false;

  photoSavedError = false;

  constructor(
    private profileService: ProfileService,
    private modalService: NgbModal,
    private oeAppPersonService: OeAppPersonService,
    private translationService: TranslationService

  ) {}

  ngOnInit() {
    this.profileService.hasUploadedPhoto().subscribe((data) => (this.hasPhoto = data === 'Y'));
  }

  onFileSelect(event) {
    if (event.target.files.length) {
      const file = event.target.files[0];
      const allowedExtensions = ['jpg', 'jpeg'];
      const allowedMimeTypes = ['image/jpeg'];
      const fileExtension = file.name.split('.').pop();

      if (
        !fileExtension ||
        !allowedExtensions.includes(fileExtension.toLowerCase()) ||
        !allowedMimeTypes.includes(file.type)
      ) {
        alert(this.translationService.translate('photoUpload.errors.fileNotSupported'));
        return;
      }

      this.photoForm.get('image').setValue(file);
      this.save();
    }
  }

  private async fileToBase64(file: File) {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
    });
  }

  async save() {
    this.isRequesting = true;
    const file = this.photoForm.get('image').value as File;
    const base64 = await this.fileToBase64(file);

    const data = {
      personId: this.oeAppPersonService.id,
      name: 'profilePicture',
      fileName: 'profilePicture.jpeg',
      contentType: 'image/jpeg',
      base64: base64,
    };

    this.profileService.uploadImage(data).subscribe(
      () => {
        this.hasPhoto = true;
        this.isRequesting = false;
        this.photoSavedError = false;
        this.modalService.open(this.photoSavedTemplate);
      },
      () => {
        this.isRequesting = false;
        this.photoSavedError = true;
        this.modalService.open(this.photoSavedTemplate);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./ts/app/preferences/personal-photo/personal-photo.component.ts